<template>
  <div class="trial">
    <va-card :title="$t('trial.cards.${titleCard}')">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Descrição" v-slot="{ errors }">
                <va-input
                  v-model="trial.descricao"
                  :label="$t('trial.headings.description')"
                  :placeholder="$t('trial.forms.description')"
                  :success="errors.length == 0 && trial.descricao.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Parceiro" v-slot="{ errors }">
                <va-select
                  :label="$t('trial.headings.partner')"
                  v-model="partner"
                  textBy="name"
                  searchable
                  :placeholder="$t('trial.forms.partner')"
                  :noOptionsText="$t('trial.headings.noPartner')"
                  maxHeight='200px'
                  :error="errors.length > 0"
                  :messages="errors"
                  :options="partners.length > 0 ? partners : []"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Data expiração" v-slot="{ errors }">
                <va-date-picker
                  :label="$t('trial.headings.expirationDate')"
                  :placeholder="$t('trial.forms.expirationDate')"
                  :config="{enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true}"
                  :error="errors.length > 0"
                  :messages="errors"
                  v-model="trial.datetime"
                />
              </ValidationProvider>
              <ValidationProvider rules="required|numeric" name="Quantidade" v-slot="{ errors }">
                <va-input
                  v-model="trial.qtd"
                  type="number"
                  :label="$t('trial.headings.amount')"
                  :placeholder="$t('trial.forms.amount')"
                  :success="errors.length == 0 && trial.qtd > 0"
                  :error="errors.length > 0 || trial.qtd <= 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'TrialAddUpdate',
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      trial: {
        descricao: '',
        partnerId: '',
        datetime: '',
        qtd: 0,
      },
      partner: '',
      partners: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  apollo: {
    partners: {
      query: gql`
      query myquery {
        partners: partner(order_by: {id: asc},  where: {tipo: {_eq: 1}}) {
          id
          name
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          const partners = data.partners
          this.partners = partners
          if (partners.length > 0 && this.partner === '') {
            this.partner = Object.assign({}, partners[0])
          }
        }
      },
    },
  },
  mounted () {
    this.partner = ''
    this.trial.descricao = ''
    this.trial.partnerId = ''
    this.trial.datetime = ''
    this.trial.qtd = 1
    if (this.updateData !== null) {
      this.trial_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (this.updateData !== null) {
        this.trial_get(this.updateData)
      } else {
        this.partner = ''
        this.trial.descricao = ''
        this.trial.partnerId = ''
        this.trial.datetime = ''
        this.trial.qtd = 1
      }
    },
    partner (value) {
      if (value !== '') {
        this.trial.partnerId = value.id
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    trial_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          if (value === 'descricao') {
            this.trial.descricao = data[value]
          } else if (value === 'partnerId') {
            this.trial.partnerId = data[value]
          } else if (value === 'expiration_date') {
            this.trial.datetime = data[value]
          } else if (value === 'qtd') {
            this.trial.qtd = data[value]
          } else if (value === 'partner') {
            this.partner = data[value]
          } else {
            this.trial[value] = data[value]
          }
        }
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')

      const { descricao, partnerId, qtd, datetime } = this.trial
      const self = this
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
              mutation MyMutation($id: Int!, $descricao: String!, $datetime: timestamptz!, $partnerId: Int, $qtd: Int!) {
                update_trial_by_pk(pk_columns: {id: $id}, _set: {descricao: $descricao, expiration_date: $datetime, partner_id: $partnerId, qtd: $qtd}) {
                  id
                }
              }
              ` : gql`
              mutation MyMutation($descricao: String!, $datetime: timestamptz!, $partnerId: Int, $qtd: Int!) {
                insert_trial_one(object: {descricao: $descricao, expiration_date: $datetime, qtd: $qtd, partner_id: $partnerId}) {
                  id
                }
              }
              `
          ),
          variables: this.updateData !== null ? {
            datetime: datetime || null,
            partnerId: partnerId,
            descricao: descricao,
            qtd: qtd,
            id: this.trial.id,
          } : {
            datetime: datetime || null,
            partnerId: partnerId,
            descricao: descricao,
            qtd: qtd,
          },
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.partner = ''
          self.trial.descricao = ''
          self.trial.partnerId = ''
          self.trial.datetime = ''
          self.trial.qtd = 0
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.chatBlock.message = ''
          self.chatBlock.datetime = ''
          self.chatBlock.clientId = ''
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
</style>
